export const defaultFontSizes = [5, 5.5, 6.5, 7.5, 8, 9, 10, 11, 12, 13, 14];